import { OwcButton } from "@one/react";
import { Variant } from "@one/web-components";

import { FormSubmitButton } from "./FormSubmitButton";
import { THEME } from "@digitallab/grid-common-frontend-components";
import { react18WorkaroundProps } from "../../../../utils/constants/react18WorkaroundProps";

type Props = {
  confirmOnly: boolean;
  cancelText: string;
  onClose: (type: "resolve" | "reject") => void;
  children?: React.ReactNode;
  confirmButtonVariant: Variant;
  centeredButtons?: boolean;
  confirmText: string;
  type?: "dialog" | "form";
};
export const FormFooterWithButtons = ({
  confirmOnly,
  cancelText,
  onClose,
  children,
  confirmButtonVariant,
  centeredButtons,
  confirmText,
  type
}: Props) => (
  <div
    slot="footer"
    style={{
      display: "flex",
      justifyContent: centeredButtons ? "center" : "flex-end",
      paddingBottom: THEME["one-spacer-16"],
  }}>
    {!confirmOnly && (
      <OwcButton
        {...react18WorkaroundProps}
        style={{
          margin: 2,
          marginRight: THEME["one-spacer-12"]
        }}
        variant="secondary"
        onClick={() => onClose("reject")}
      >
        {cancelText}
      </OwcButton>
    )}
    {type === "form" ? (
      <FormSubmitButton confirmButtonVariant={confirmButtonVariant} confirmText={confirmText} />
    ) : (
      <OwcButton
        {...react18WorkaroundProps}
        style={{ margin: 2 }}
        variant={confirmButtonVariant}
        onClick={async (e: React.MouseEvent<HTMLOwcButtonElement>) => {
          onClose("resolve");
        }}
      >
        {confirmText}
      </OwcButton>
    )}
    {children}
  </div>
);
